import { render, staticRenderFns } from "./addtestpaper.vue?vue&type=template&id=2fa07fca"
import script from "./addtestpaper.vue?vue&type=script&lang=js"
export * from "./addtestpaper.vue?vue&type=script&lang=js"
import style0 from "./addtestpaper.vue?vue&type=style&index=0&id=2fa07fca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports